// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__7X43A","head":"ProcedureTableInfo_head__3Rc7T"};